import { render, staticRenderFns } from "./topUsersyear.vue?vue&type=template&id=a3bd68f4"
import script from "./topUsersyear.vue?vue&type=script&lang=js"
export * from "./topUsersyear.vue?vue&type=script&lang=js"
import style0 from "./topUsersyear.vue?vue&type=style&index=0&id=a3bd68f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports